export default {
  navigation: {
    activeView: "",
    activeViewIndex: 0,
    views: []
  },
  activeUGCComponent: null,
  isCreatingAssets: false,
  canvasConfig: {
    color1: null,
    color2: null,
    size: 'medium',
    warp: 'noWarp'
  },
  buttonBackgroundImageUrl: null,
  enableControls: true,
  model: 'slip-on-classic',
  uploadedImage: {
    id: null,
    url: null,
  },
  components: {},
  availableModels: [],
  useSecondView: false,
  useSameUploadedImage: false,
  tempComponents: {},
  skipWarpSelector: false,
  sizeData: null,
  productType: false,
  source: ''
}
